import {httpGet, httpPost} from "./api/axios_api";
import Constants from "../constants/constants";
import {result} from './api/entities';

export const actions = {
    resetResultState: "RESET_RESULT_STATE",
    createResult: "CREATE_RESULT",
    updateResult: "UPDATE_RESULT",
    listResult: "LIST_RESULT",
    getResult: "GET_RESULT",
    getPlayerMinutesPlayer: "GET_MINUTES_PLAYED",
    updateMinutesPlayed: "UPDATE_MINUTES_PLAYED",
    getPlayerAngleData: "GET_PLAYER_ANGLE_DATA",
    updateAngleData: "UPDATE_ANGLE_DATA",
    getPlayerROMData: "GET_PLAYER_ROM_DATA",
    updatePlayerROMData: "UPDATE_PLAYER_ROM_DATA"
};


export async function getProgressKeys(token) {
    let url = `${Constants.BACKEND_URL}/get-progress-keys`;

    return httpGet(url, {}, token);
}

export async function getWorldCupResults(token) {
    let url = `${Constants.BACKEND_URL}/get-world-cup-leaderboard-stats`;

    return httpGet(url, {}, token);
}

export async function getPlayerProgress(playerID, gameID, skillID, positionID, func_type, relevantKey, token) {
    let url = `${Constants.BACKEND_URL}/get-player-progress`;

    let params = {
        "relevant_key": relevantKey,
        "player_id": playerID,
        "game_id": gameID,
        "skill_id": skillID,
        "position_id": positionID,
        "func_type": func_type
    };
    
    let config = {
        params: params
    };

    return httpPost(url, config, token); 
}


export async function getPlayerFavoriteGame(playerID, token) {
    let url = `${Constants.BACKEND_URL}/get-player-favorite-game/${playerID}`;
    return httpGet(url, {}, token);
}

export async function getPlayerFavoritePosition(playerID, token) {
    let url = `${Constants.BACKEND_URL}/get-player-favorite-position/${playerID}`;
    return httpGet(url, {}, token);
}

export async function getPlayerGameResultsForSummary(playerID, token) {
  let url = `${Constants.BACKEND_URL}/get-player-results-for-summary/${playerID}`;
  return httpGet(url, {}, token);
}

export async function getPlayerGameSessionResultsAsync(playerGameSessionID, token) {
  let url = `${Constants.BACKEND_URL}/get-player-game-session-results/${playerGameSessionID}`;
  return httpGet(url, {}, token);
}

export function getPlayerROMData(playerID, token) {
  return dispatch => {
      let url = `${Constants.BACKEND_URL}/player-rom-overview/${playerID}`;
      httpGet(url, {}, token).then((response) => {
          if (response.data.success) {
              dispatch({
                  type: actions.updatePlayerROMData,
                  rom_data: response.data.data
              })
          }
          else {
              //TODO: handle results load error
          }

      })
  }
}


export function getPlayerAngleSectionData(playerID, token) {
  return dispatch => {
      let url = `${Constants.BACKEND_URL}/player-angle-overview/${playerID}`;
      httpGet(url, {}, token).then((response) => {
          if (response.data.success) {
              dispatch({
                  type: actions.updateAngleData,
                  angle_data: response.data.data
              })
          }
          else {
              //TODO: handle results load error
          }

      })
  }
}

export function getPlayerMinutesPlayed(playerID, token) {
  return dispatch => {
      let url = `${Constants.BACKEND_URL}/player-minutes-played/${playerID}`;
      httpGet(url, {}, token).then((response) => {
          if (response.data.success) {
              dispatch({
                  type: actions.updateMinutesPlayed,
                  minutes_played: response.data.data
              })
          }
          else {
              //TODO: handle results load error
          }

      })
  }
}

export function resetResultState() {
    return {type: actions.resetResultState}
}

export function startMinutesPlayedFetch() {
  return {type: actions.getPlayerMinutesPlayer}
}

export function startAngleDataFetch() {
  return {type: actions.getPlayerAngleData}
}

export function createResult(resultObject) {
    return result.create(actions.createResult, resultObject, []);
}

export function updateResult(resultId, resultObject) {
    return result.update(actions.updateResult, resultId, resultObject, []);
}

export function getResults(query, sort) {
    return result.list(actions.listResult, query, sort);
}

export function getResult(resultId) {
    return result.get(actions.getResult, resultId, []);
}

const INITIAL_STATE = {
    results: [],
    result: {}
};

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.resetResultState:
            return {
                ...INITIAL_STATE
            };
        case actions.createResult:
            return {
                ...state,
                results: action.body ? [...state.results, action.body] : state.results
            };
        case actions.listResult:
            return {
                ...state,
                results: action.body ? action.body._items : state.results
            };
        case actions.getResult:
            return {
                ...state,
                result: action.body ? action.body : state.result
            };
        case actions.updateResult:
            return {
                ...state,
                id: action.body ? action.body : null
            };
        case actions.getPlayerMinutesPlayer:
            return {
              ...state,
              minutes_played: []
            }
        case actions.updateMinutesPlayed:
            return {
                ...state,
                minutes_played: action.minutes_played
            }
        case actions.getPlayerAngleData:
            return {
              ...state,
              angle_data: []
            }
        case actions.updateAngleData:
            return {
                ...state,
                angle_data: action.angle_data
            }
        case actions.getPlayerROMData:
            return {
              ...state,
              rom_data: []
            }
        case actions.updatePlayerROMData:
            return {
                ...state,
                rom_data: action.rom_data
            }
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/modules/result.js